import React from 'react';
import loadable from '@loadable/component';

export default loadable(
    () =>
        import(/* webpackChunkName: "LazyRewardDashboardChunks" */ './RewardsHistoryScreenConnect'),
    {
        fallback: <div>Loading...</div>,
    }
);
